var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsGivenRecognition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "36px",
    viewBox: "0 0 40 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget-Concept-ES-v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.785714, 0.000067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999714,31.9999237 C18.6249556,31.9999237 23.9999428,26.6249365 23.9999428,19.9999523 C23.9999428,13.3749681 18.6249556,0 11.9999714,0 C5.37498719,0 0,13.3749681 0,19.9999523 C0,26.6249365 5.37498719,31.9999237 11.9999714,31.9999237 Z",
    id: "egg",
    fill: "#FF7F7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    transform: "translate(26.714286, 23.499933) rotate(-360.000000) translate(-26.714286, -23.499933) ",
    cx: 26.7142857,
    cy: 23.4999332,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7142857,31.9999332 C31.4098502,31.9999332 35.2142857,28.1954978 35.2142857,23.4999332 C35.2142857,18.8043687 31.4098502,14.9999332 26.7142857,14.9999332 C22.0187212,14.9999332 18.2142857,18.8043687 18.2142857,23.4999332 C18.2142857,28.1954978 22.0187212,31.9999332 26.7142857,31.9999332 Z M27.8110599,27.88703 L25.6175115,27.88703 C25.3913152,27.88703 25.2062212,27.701936 25.2062212,27.4757397 L25.2062212,23.4999332 L22.7761675,23.4999332 C22.4094604,23.4999332 22.2243664,23.0577828 22.4848368,22.7973123 L26.4263691,18.8797786 C26.5874645,18.7186832 26.844521,18.7186832 27.0056164,18.8797786 L30.9437346,22.7973123 C31.2042051,23.0543687 31.019111,23.4999332 30.6524039,23.4999332 L28.2223502,23.4999332 L28.2223502,27.4757397 C28.2223502,27.701936 28.0372562,27.88703 27.8110599,27.88703 Z M26.7142857,31.9999332 C31.4098502,31.9999332 35.2142857,28.1954978 35.2142857,23.4999332 C35.2142857,18.8043687 31.4098502,14.9999332 26.7142857,14.9999332 C22.0187212,14.9999332 18.2142857,18.8043687 18.2142857,23.4999332 C18.2142857,28.1954978 22.0187212,31.9999332 26.7142857,31.9999332 Z M27.8110599,27.88703 L25.6175115,27.88703 C25.3913152,27.88703 25.2062212,27.701936 25.2062212,27.4757397 L25.2062212,23.4999332 L22.7761675,23.4999332 C22.4094604,23.4999332 22.2243664,23.0577828 22.4848368,22.7973123 L26.4263691,18.8797786 C26.5874645,18.7186832 26.844521,18.7186832 27.0056164,18.8797786 L30.9437346,22.7973123 C31.2042051,23.0543687 31.019111,23.4999332 30.6524039,23.4999332 L28.2223502,23.4999332 L28.2223502,27.4757397 C28.2223502,27.701936 28.0372562,27.88703 27.8110599,27.88703 Z",
    id: "aarrow-alt-circle-up-copy",
    fill: "#FF7F7F",
    fillRule: "nonzero",
    transform: "translate(26.714286, 23.499933) rotate(-270.000000) translate(-26.714286, -23.499933) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsGivenRecognition);
export default __webpack_public_path__ + "static/media/stats-given-recognition.2054d1e77258e4421c0dcb80f0f98a78.svg";
export { ForwardRef as ReactComponent };